import React from 'react';
import { formatCurrency } from "js/services/Format";
import Row from './Row';

const ItemView = ({
  item,
}) => {
  const q = item.quantity || 1;

  return (
    <div>
      <div className='tw-flex tw-mb-2 tw-text-sm tw-justify-between tw-items-center'>
        <div className="tw-flex tw-gap-3">
          <img src={item.images[0]} height="60px" width="60px" className='tw-rounded-md' />
          <div>
            <p className="tw-font-bold tw-mb-1">{item.title}</p>
            <p className="tw-font-thin tw-text-sm">{`${q} unit${q > 1 ? 's' : ''} available`}</p>
          </div>
        </div>

        <p className="tw-font-bold tw-text-secondary">{formatCurrency(item.price)}</p>
      </div>

      {item.size && <Row name="Item size" value={item.size} />}
      {item.address.address1 && <Row name="Pick-up address" value={item.address.address1} />}
      {item.address.address1 && <Row name="Pick-up time" value="within 24hrs after order" />}
    </div>
  );
}

export default ItemView;
